import { Component } from "@/decorators";
import EspecieAnimalModel from "@/models/paciente/especieAnimalModel";
import especieAnimalService from "@/services/paciente/especieAnimalService";

import EditComponentBase from "../editComponentBase";

import "../crud.scss";

@Component
export default class EspecieAnimalEditComponent extends EditComponentBase<EspecieAnimalModel> {
    private async beforeMount() {
        await this.setPropsCached(especieAnimalService, "especie_de_animal", new EspecieAnimalModel(), false, true);
    }
}
